<template>
    <div class="pa-6 mt-8 filter-container">
        <h3 id="filter-title-text">{{filterTitle}}</h3>
        <v-form ref="form">
            <v-row align="start">
                <v-col cols="12">
                    <other-periods-fields
                        :periods="getPeriods"
                        :type="getType"
                        @applyPeriod="applyPeriod($event)"
                    >
                    </other-periods-fields>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>

<script>
import moment from 'moment';
import OtherPeriodsFields from './OtherPeriodsFields.vue';
export default 
{
    name: 'SearchOtherPeriodDate',
    props:{
        type: {
            type: String,
            required: true,
            validator: (value)=>{
                return ['diario', 'mensal', 'horario', 'observado'].indexOf(value) !== -1;
            }
        }
    },
    components:{ OtherPeriodsFields, },
    data:()=>({
        dailyPeriods:[
            {label: 'Últimos 7 dias', interval: 7},
            {label: 'Últimos 30 dias', interval: 30},
            {label: 'Últimos 90 dias', interval: 90}
        ],
        monthlyPeriods:[
            {label: 'Últimos 6 meses', interval: 6},
            {label: 'Últimos 12 meses', interval: 12}
        ],
        hourlyPeriods: [
            {label: 'Últimas 12 horas', interval: 12},
            {label: 'Últimas 24 horas', interval: 24}
        ],
    }),
    computed:{
        getPeriods(){
            if(this.type === "diario") return this.createDailyDateInterval(this.dailyPeriods);
            if(this.type === "mensal") return this.createMonthlyDateInterval(this.monthlyPeriods);
            return this.createHourlyDateInterval(this.hourlyPeriods);
        },
        getType(){
            if(this.type === "diario") return "daily";
            if(this.type === "mensal") return "monthly";
            return "hourly";
        },
        filterTitle(){
            if(this.type === "diario") return "Filtros por dia";
            if(this.type === "mensal") return " Filtros por mês";
            return " Filtros por hora";
        }
    },
    methods:{
        
        createDailyDateInterval(periods){
            return periods.map((period)=>({
                ...period,
                dateTitle: `De ${moment().subtract(period.interval - 1, "days").format("DD/MM/YYYY")} a ${moment().format("DD/MM/YYYY")}`,
                dateStart: moment().subtract(period.interval - 1, "days").format("YYYY-MM-DD"),
                dateFinal: moment().format("YYYY-MM-DD"),
            }));
        },
        createMonthlyDateInterval(periods){
            return periods.map((period)=>({
                ...period,
                dateTitle: `De ${moment().subtract(period.interval - 1, "months").locale("pt-br").format("MMMM/YYYY")} a ${moment().locale("pt-br").format("MMMM/YYYY")}`,
                dateStart: moment().subtract(period.interval - 1 , "months").format("YYYY-MM"),
                dateFinal: moment().format("YYYY-MM"),
            }));
        },
        createHourlyDateInterval(periods){
            return periods.map((period)=>({
                ...period,
                dateTitle: `De ${moment().tz('America/Sao_Paulo').subtract(period.interval - 1, "hours").startOf("hour").format("DD/MM/YYYY HH:mm")} a ${moment().tz('America/Sao_Paulo').startOf("hour").format("DD/MM/YYYY HH:mm")}`,
                dateStart: moment().tz('America/Sao_Paulo').subtract(period.interval - 1 , "hours").startOf("hour").format("YYYY-MM-DDTHH:mm"),
                dateFinal: moment().tz('America/Sao_Paulo').startOf("hour").format("YYYY-MM-DDTHH:mm"),
            }));
        },
        getAPIDataType(componentType){
            if(componentType === "daily") return "diario";
            if(componentType === "monthly") return "mensal";
            return "horario";
        },
        applyPeriod(periodSelected){
            const { type }= periodSelected;
            this.$emit("applyPeriod", { ...periodSelected, type: this.getAPIDataType(type) });
        }
    }
}
</script>

<style scoped>
    .filter-container{
        background-color: var(--v-primary-darken1);
        border: 1px dashed white;
    }

    #filter-title-text{
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 20px;
        color: #fff;
    }
</style>